"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Go up through chain of prototypes.
 * @param object First object in the chain
 * @param callback Function is called for every object in the chain (not called for null)
 */
function walkThroughPrototypes(object, callback) {
    if (object === null) {
        return;
    }
    else {
        callback(object);
        walkThroughPrototypes(Object.getPrototypeOf(object), callback);
    }
}
exports.walkThroughPrototypes = walkThroughPrototypes;
/**
 * Go up through prototype chain. If give prototype has property name then add it to returned result
 * @param object first object in the chain
 * @param propertyName name of the property that will be taken from each of prototype
 * @returns Array of values of collected properties
 */
function collectAncestralProperties(object, propertyName) {
    var result = [];
    walkThroughPrototypes(object, function (currentProto) {
        if (currentProto.hasOwnProperty(propertyName)) {
            result.push(currentProto[propertyName]);
        }
    });
    return result;
}
exports.collectAncestralProperties = collectAncestralProperties;
